<template>
  <div class="content">
    <div class="process-container">
      <div class="line-box">
        <div class="grayLine" :style="{backgroundColor:vipConfigList[level].color5}">
          <div class="colorLine" :style="{width:decimalToPercent(),backgroundColor:vipConfigList[level].color4}">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['current', 'total', 'vipConfigList', 'level'],
  data () {
    return {
    }
  },
  methods: {
    // 小数转化百分比
    decimalToPercent () {
      let data = '100%'
      if (this.current < this.total) {
        data = ((this.current / this.total) * 100).toFixed(2) + '%'
      }
      return data
    }
  }
}
</script>

<style scoped lang="less">
.content {
  .process-container {
    align-items: center;
  }
  .bot {
    margin: 0 30px;
  }
.line-box{
  display: flex;
  height: 25px;
  width: 100%;
  margin: auto;
  .grayLine {
    margin: auto;
    height: 2.45vw;
    width: 100%;
    border-radius: 4px;
    .colorLine {
      height: 100%;
      border-radius: 4px;
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/ProgressLine/index.vue